import React, { useState } from 'react';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from '../../firebase';

const ImageUploader = ({ folder, onUpload, currentUrl }) => {
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const path = `${folder}/${Date.now()}_${file.name}`;
    const uploadTask = uploadBytesResumable(ref(storage, path), file);
    uploadTask.on('state_changed',
      snap => setProgress(Math.round(snap.bytesTransferred / snap.totalBytes * 100)),
      () => setUploading(false),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(url => {
          onUpload(url);
          setUploading(false);
          setProgress(0);
        });
      }
    );
  };

  return (
    <div className="admin-image-uploader">
      {currentUrl && <img src={currentUrl} alt="preview" className="admin-img-preview" />}
      <input type="file" accept="image/*" onChange={handleFile} />
      {uploading && <div className="admin-progress"><div style={{ width: `${progress}%` }} /></div>}
    </div>
  );
};

export default ImageUploader;
